import { Box, Button, useTheme } from "@mui/material";
import { WorldRenderer } from "../../WorldRenderer";
import { PointSelectedEvent } from "../PlanetService";
import { PropValueLine } from "../../common/PropValueLine";
import { WREvents } from "../../WREvents";
import { RenderAccordionToolbar } from "../../../components/Minibar";

export function PointProps({
  wr,
  point,
  pinned,
  panel,
  togglePin,
}: {
  wr: WorldRenderer;
  point: PointSelectedEvent;
  pinned: Set<string>;
  panel: string;
  togglePin: (panel: string) => void;
}) {
  const theme = useTheme();
  return (
    <>
      <RenderAccordionToolbar
        pinned={pinned}
        panel={panel}
        togglePin={togglePin}
      />
      <Box>
        <PropValueLine label="MGRS" value={point.mgrs} />
        <PropValueLine label="Lat" value={point.latLonAlt.lat.toFixed(6)} />
        <PropValueLine label="Lon" value={point.latLonAlt.lon.toFixed(6)} />
        <PropValueLine label="Alt" value={point.latLonAlt.alt.toFixed(2)} />
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={async () => {
            const site = await wr.dataService.addSite(
              "New Site",
              point.latLonAlt,
              point.mgrs
            );
            wr.emitEvent(WREvents.VisualSelected, site);
          }}
        >
          Create Site
        </Button>
      </Box>
    </>
  );
}
